import React from 'react';
import Icon from '@pushpay/icon';
import { createUseStyles, clsx } from '@pushpay/styles';
const useStyles = createUseStyles(theme => ({
  root: {
    color: theme.colors['color-text-placeholder']
  }
}));

const OrgPlaceholderIcon = ({
  classes: classesProp,
  className: classNameProp,
  ...rest
}) => {
  const classes = useStyles(classesProp);
  const className = clsx(classNameProp, classes.root);
  return /*#__PURE__*/React.createElement(Icon, Object.assign({
    viewBox: "0 0 24 24",
    className: className
  }, rest), /*#__PURE__*/React.createElement("circle", {
    fill: "#E3E5E9",
    cx: 12,
    cy: 12,
    r: 12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.879 9.15c.14 0 .253.112.253.25v7.75c0 .138-.114.25-.253.25H9.837a.251.251 0 01-.253-.25V9.4c0-.138.113-.25.253-.25zM8.574 11.9c.14 0 .252.112.252.25v5c0 .138-.113.25-.252.25H6.553a.251.251 0 01-.253-.25v-5c0-.138.113-.25.253-.25zm6.486-1.188a.382.382 0 01.357-.031l2.653 1.125c.14.058.23.194.23.344v4.875c0 .207-.17.375-.379.375h-2.653a.377.377 0 01-.379-.375v-6c0-.126.065-.243.17-.313zm-7.497 4.313a.377.377 0 00-.379.375v.5c0 .207.17.375.38.375.208 0 .378-.168.378-.375v-.5a.377.377 0 00-.379-.375zm8.337-.25a.377.377 0 00-.379.375v.5c0 .207.17.375.379.375.21 0 .379-.168.379-.375v-.5a.377.377 0 00-.379-.375zm1.263 0a.377.377 0 00-.379.375v.5c0 .207.17.375.38.375.208 0 .378-.168.378-.375v-.5a.377.377 0 00-.379-.375zm-6.19-4.5a.377.377 0 00-.378.375v5c0 .207.17.375.379.375s.379-.168.379-.375v-5a.377.377 0 00-.38-.375zm1.77 0a.377.377 0 00-.38.375v5c0 .207.17.375.38.375.208 0 .378-.168.378-.375v-5a.377.377 0 00-.379-.375zm-5.18 2.75a.377.377 0 00-.379.375v.5c0 .207.17.375.38.375.208 0 .378-.168.378-.375v-.5a.377.377 0 00-.379-.375zm8.337-.5a.377.377 0 00-.379.375v.5c0 .207.17.375.379.375.21 0 .379-.168.379-.375v-.5a.377.377 0 00-.379-.375zm1.263 0a.377.377 0 00-.379.375v.5c0 .207.17.375.38.375.208 0 .378-.168.378-.375v-.5a.377.377 0 00-.379-.375zM11.858 5.4c.279 0 .505.224.505.5v.688a.25.25 0 00.101.2l1.567 1.162a.248.248 0 01.088.28.252.252 0 01-.24.17H9.837a.252.252 0 01-.24-.17.248.248 0 01.088-.28l1.567-1.163a.25.25 0 00.1-.2V5.9c0-.276.227-.5.506-.5z",
    fill: "currentColor"
  }));
};

export default OrgPlaceholderIcon;